/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {SiteMapArticleCategory} from "../../site_map/views/SiteMapArticleCategory";
import {SiteMapArticleCategoryList} from "../../site_map/views/SiteMapArticleCategoryList";
import {SiteMapCommercialOffers} from "../../site_map/views/SiteMapOffersType/SiteMapCommercialOffers";
import {SiteMapFlatOffers} from "../../site_map/views/SiteMapOffersType/SiteMapFlatOffers";
import {SiteMapHouseOffers} from "../../site_map/views/SiteMapOffersType/SiteMapHouseOffers";
import {SiteMapOffersVoivodeship} from "../../site_map/views/SiteMapOffersVoivodeship";
import {SiteMapOffersVoivodeshipList} from "../../site_map/views/SiteMapOffersVoivodeshipList";
import {SiteMapVendors} from "../../site_map/views/SiteMapVendors";
import {SiteMapView} from "../../site_map/views/SiteMapView";
const route = [
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.base, component: SiteMapView},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.article.base, component: SiteMapArticleCategoryList},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.article.category, component: SiteMapArticleCategory},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.vendor, component: SiteMapVendors},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.house, component: SiteMapHouseOffers},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.flat, component: SiteMapFlatOffers},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.commercial, component: SiteMapCommercialOffers},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.offer.base, component: SiteMapOffersVoivodeshipList},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.offer.voivodeship, component: SiteMapOffersVoivodeship}
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {SiteMapArticleCategory} from "../../site_map/views/SiteMapArticleCategory";
import {SiteMapArticleCategoryList} from "../../site_map/views/SiteMapArticleCategoryList";
import {SiteMapCommercialOffers} from "../../site_map/views/SiteMapOffersType/SiteMapCommercialOffers";
import {SiteMapFlatOffers} from "../../site_map/views/SiteMapOffersType/SiteMapFlatOffers";
import {SiteMapHouseOffers} from "../../site_map/views/SiteMapOffersType/SiteMapHouseOffers";
import {SiteMapOffersVoivodeship} from "../../site_map/views/SiteMapOffersVoivodeship";
import {SiteMapOffersVoivodeshipList} from "../../site_map/views/SiteMapOffersVoivodeshipList";
import {SiteMapVendors} from "../../site_map/views/SiteMapVendors";
import {SiteMapView} from "../../site_map/views/SiteMapView";
const route = [
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.base, component: SiteMapView},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.article.base, component: SiteMapArticleCategoryList},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.article.category, component: SiteMapArticleCategory},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.vendor, component: SiteMapVendors},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.house, component: SiteMapHouseOffers},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.flat, component: SiteMapFlatOffers},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.commercial, component: SiteMapCommercialOffers},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.offer.base, component: SiteMapOffersVoivodeshipList},
    {webpackEntry: "siteMaps", path: rpAppPath.siteMap.offer.voivodeship, component: SiteMapOffersVoivodeship}
];

(function () {
    rpClient(route);
})();
